import Avatar from "@mui/material/Avatar";

import { useAuth } from "@/providers/auth";
import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { OrganizationType } from "@/shared/domain/orgs";
import { KeyboardArrowDownIcon } from "@/shared/foundation/icons/mui";
import { usePopupState } from "@/shared/hooks";

import styles from "./OrgSettingsButton.module.css";
import { OrgSettingsMenu } from "./OrgSettingsMenu";

/**
 * Button showing the user's current org and displays
 * a menu of the user's setting options for example,
 * account settings, switch org, logout, etc.
 */
export function OrgSettingsButton() {
  const orgName = useOrgName();
  const popup = usePopupState();

  return (
    <>
      <div
        role="button"
        className={styles.button}
        onClick={(event) =>
          popup.open({
            anchorEl: event.currentTarget,
          })
        }
      >
        <Avatar variant="rounded" className={styles.orgIcon}>
          {orgName.charAt(0)}
        </Avatar>
        <div className={styles.dropdown}>
          <RobotoTypography
            className={styles.orgName}
            title={orgName}
            variant="body1"
          >
            {orgName}
          </RobotoTypography>
          <KeyboardArrowDownIcon className={styles.menuButtonIcon} />
        </div>
      </div>
      <OrgSettingsMenu anchorEl={popup.anchor} handleClose={popup.close} />
    </>
  );
}

function useOrgName(): string {
  const { currentOrganization, currentUser } = useAuth();

  const userEmail = currentUser?.user_id;
  const fallbackOrgName = "Roboto AI";

  if (currentOrganization) {
    if (currentOrganization.org_type === OrganizationType.Individual) {
      return userEmail ?? fallbackOrgName;
    } else {
      return currentOrganization.name;
    }
  } else if (userEmail) {
    return userEmail;
  }

  return fallbackOrgName;
}
